import Phaser from 'phaser';
import gameData from '../gameData';
import MathLinesInst from '../mathLines/MathLinesInst';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import GameHUD from '../UI/GameHUD';
import GameArea from '../mathLines/GameArea';
import EndDialog from '../UI/EndDialog';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  create() {
    console.log('Game');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._math_lines_music, this, .5, true);

    this.instShowing = false;
    this.gameArea = new GameArea(this);
    this.gameArea.setUpArea(gameData.level);
    this.gameArea.on('GAME_STAGE_END', (e) => {this.handleStageEnd(e);});

    this.hud = new GameHUD(this);

    this.hud.on('HUD_INPUT', (e) => {this.handleUiInput(e);});

    if (gameData.themePlaying === false) this.hud.showMusicState(false);
  }

  handleUiInput(e) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    // toggle sound or show inst
    if (e === 'music') {
      this.toggleMusic();
    }
    else {
      if (this.instShowing === false) {
        this.showInst();
      }
    }
  };

  showInst() {
    this.instShowing = true;
    this.gameArea.toggleLevelReady(false);
    const instContainer = new MathLinesInst(this);
    instContainer.once('INST_FINISHED', () => {this.removeInst();});
  };

  removeInst() {
    this.instShowing = false;
    if (this.gameArea.levelRunning === true) this.gameArea.toggleLevelReady(true);
  };

  toggleMusic() {
    if (gameData.themePlaying === true) {
      gameData.themePlaying = false;
      this.sound.setVolume(0);
      this.hud.showMusicState(false);
    }
    else {
      gameData.themePlaying = true;
      this.sound.setVolume(1);
      this.hud.showMusicState(true);
    }
  };

  update() {
    // update score if nesessary
    if (this.hud) {
      if (this.hud.scoreBox.scoreNum !== gameData.score) {
        this.hud.scoreBox.updateScore(gameData.score);
      }
    }
    if (this.gameArea) this.gameArea.updateGame();
  };

  layoutRatio() {
    // position gameArea
    if (this.gameArea) this.gameArea.layoutGame();
  };

  handleStageEnd(e) {
    if (e === false) {
      console.log('END', e);

      // add end right on game screen
      const endDialog = new EndDialog(this, ['PLAY AGAIN','HOME'],'nope');
      endDialog.x = this.mid.x - endDialog.getBounds().width / 2;
      endDialog.y = -(endDialog.getBounds().height / 2);

      endDialog.on('DIALOG_SELECT', (e) => {this.handleDialogInput(e);});

      ABCyaPhaser.Tweens.addTween(endDialog, 600, { y: this.mid.y - endDialog.getBounds().height / 2 }, Phaser.Math.Easing.Back.Out);

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._gameOver, this);
    }
    else {
      // show end screen if game is complete;
      this.cleanUp('END');
    }
  };

  handleDialogInput(e) {
    this.gameArea.cleanUp();

    this.cleanUp(e);
  };

  cleanUp(nextStep) {
    this.sound.stopAll();
    this.tweens.killAll();

    this.children.removeAll(true);

    if (nextStep === 'END') {
      this.scene.start('End');
    }
    else if (nextStep === 'HOME') {
      this.scene.start('Intro');
    }
    else {
      this.scene.start('Game');
    }
  };
}